import {
  travelModel,
  carModel,
  motorModel,
  accidentModel,
  petModel,
  vaccineModel,  
} from '@/utils/asyncValidator/queryForms';
//20210530 Wen Modify
const initialQueryModel = (state, getters, rootState) => {
  const { isLogin, profile: { dateOfBirth } } = rootState.user;
  const { gender } = getters.userInfo;
  return {
    travel: travelModel,
    car: isLogin ? { ...carModel, dateOfBirth, gender: gender.value } : carModel,
    motor: isLogin ? { ...motorModel, dateOfBirth } : motorModel ,
    accident: accidentModel,
    pet: petModel,
    vaccine: vaccineModel,
  };
};

export default {
  initialQueryModel
};